<template>
  <div class="toggler" :class="{ 'disabled': !text }">
    <button 
      v-if="text"
      class="btn btn--more-or-less process-white"
      @click="toggleMoreText"
      :class="{ 'less': showMoreText }"
    >Read</button>

    <div class="toggler__text" v-html="text" :class="{ 'active': showMoreText }"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const showMoreText = ref(false);

    const toggleMoreText = () => {
      showMoreText.value = !showMoreText.value;
    };

    onMounted(() => {
      // Set showMoreText to false on mount
      showMoreText.value = false;
    });

    return {
      showMoreText,
      toggleMoreText,
    };
  },
};
</script>

<style lang="scss">
.toggler {
  &.disabled {
    height: 9rem;
  }
  &__text {
    opacity: 0;
    transition: opacity 0.75s ease, transform 0.75s ease;
    transform: translateY(3rem);
    &.active {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
